<script lang="ts" setup>
import { computed, PropType } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import WatchLaterButton from "@/components/atoms/button/WatchLaterButton.vue";

const props = defineProps({
  hasSub: {
    type: Boolean,
    default: false
  },
  isDisabled: {
    type: Boolean,
    default: false
  },
  isShownWatchLaterButton: {
    type: Boolean,
    default: false
  },
  isRegisteredWatchLater: {
    type: Boolean,
    default: false
  },
  enabledVariant: {
    type: String,
    default: "secondary"
  },
  abTestGroup3300: {
    type: String as PropType<"B" | "C" | null>,
    default: null
  }
});

const className = computed(() => {
  return props.hasSub ? "py-1" : null;
});
const variant = computed(() => {
  return props.isDisabled ? "gray-03" : props.enabledVariant;
});
const watchLaterButtonWrapperClass = computed(() => {
  return props.isShownWatchLaterButton ? "flex-grow-1" : null;
});
const applyButtonWrapperClass = computed(() => {
  return props.isShownWatchLaterButton ? "flex-grow-11" : "flex-grow-1";
});
const buttonClass = computed(() => {
  if (props.isDisabled || props.abTestGroup3300 === null) {
    return null;
  }

  return `ab-test-group-3300-${props.abTestGroup3300.toLowerCase()}`;
});

const emits = defineEmits(["change-watch-later", "click"]);

function onChangeWatchLater() {
  emits("change-watch-later");
}
function onClick() {
  emits("click");
}
</script>

<template>
  <div class="fixed-button">
    <div class="d-flex justify-content-start align-items-center">
      <div v-if="isShownWatchLaterButton" :class="watchLaterButtonWrapperClass">
        <WatchLaterButton
          :isRegisteredWatchLater="isRegisteredWatchLater"
          @click="onChangeWatchLater"
          data-testid="watch-later-button"
        />
      </div>
      <div :class="applyButtonWrapperClass">
        <AppButton
          block
          :class="[className, buttonClass]"
          :variant="variant"
          :disabled="isDisabled"
          @click="onClick"
        >
          <slot />
          <div class="text-size-10 line-height-14">
            <slot name="sub" />
          </div>
        </AppButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.fixed-button {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  padding: 8px 16px 28px;
  background-color: white;
  border-top: 1px solid #e5e5e5;

  /* ABテスト3300のグループ別スタイル */
  :deep(.ab-test-group-3300-b) {
    color: white !important;
    background-color: #009be1 !important;
    border-color: #009be1 !important;
  }

  :deep(.ab-test-group-3300-c) {
    color: white !important;
    background-color: #5089e5 !important;
    border-color: #5089e5 !important;
  }
}

.flex-grow-11 {
  flex-grow: 11;
}
</style>
